import Cookies from 'js-cookie';
import React, {Fragment} from 'react';

class Modal extends React.Component {
  static defaultProps = {
    containerClassName: '',
    modalInnerClassName: '',
    disableHistory: false,
    disableClickOutsideToClose: false,
    disableEscapeToClose: false,
    onCloseCallback: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      toggleDisabled: false,
    };
  }

  componentDidMount = () => {
    this.handleHashChange();
    window.addEventListener('hashchange', this.handleHashChange);
    window.addEventListener('keydown', this.handleEscapeKeypress);
  };

  toggleZendeskWidget = () => {
    if(typeof(window.zEmbed) !== 'undefined' &&
      typeof(window.zEmbed.hide) !== 'undefined' &&
      typeof(window.zEmbed.show) !== 'undefined') {
      this.state.show ? window.zEmbed.hide() : window.zEmbed.show();
    }
  };

  setToggleDisabled = (disabled, callback) => {
    if (callback === undefined) {
      this.setState({
        toggleDisabled: disabled,
      });
    } else {
      this.setState({
        toggleDisabled: disabled,
      }, callback);
    }
  };

  handleHashChange = () => {
    if(this.props.disableHistory) return;
    if(!this.state.show && this.hashMatchesModal()) this.toggle();
    if(this.state.show && window.location.hash === '') this.toggle();
  }

  handleEscapeKeypress = (event) => {
    if(event.keyCode === 27 && this.state.show && !this.props.disableEscapeToClose) this.toggle();
  };

  toggle = (show) => {
    if(this.state.toggleDisabled) return false;


    this.setState({
      show: typeof show === 'boolean' ? show : !this.state.show,
    }, () => {
      this.toggleZendeskWidget();

      if(this.state.show) {
        this.scrollPosition = $(document).scrollTop();
        this.bodyMarginTop = $('body').css('margin-top');

        if(!this.props.disableHistory) window.location.hash = this.props.modalId;
        $('body').addClass('modal-open');
        $('body').css('margin-top', `-${this.scrollPosition}px`);

        document.dispatchEvent(new CustomEvent('ModalOpened', { detail: {
          modalId: this.props.modalId,
        }}));

        if(window.analytics !== undefined) {
          window.analytics.track('Viewed Modal', {
            name: this.props.modalName,
            label: this.props.modalName,
            utm: Cookies.get('maji_utm'),
          });
        }
      } else {
        if(this.props.onCloseCallback) this.props.onCloseCallback();

        if(!this.props.disableHistory) window.location.hash = '';

        $('body').removeClass('modal-open');
        $('body').css('margin-top', this.bodyMarginTop);
        $(document).scrollTop(this.scrollPosition);

        document.dispatchEvent(new CustomEvent('ModalClosed', { detail: {
          modalId: this.props.modalId,
        }}));
      }
    });
  };

  hashMatchesModal = () => window.location.hash == `#${this.props.modalId}`;

  render() {
    return (
      <Fragment>
        {this.state.show &&
          <div
            className={`modal ${this.props.containerClassName}`}
            onClick={() => { if (!this.props.disableClickOutsideToClose) this.toggle(); }}
          >
            <div
              className={`modal-inner ${this.props.modalInnerClassName}`}
              onClick={e => e.stopPropagation()}
            >
              {!this.state.toggleDisabled &&
                <div
                  className='modal-close'
                  onClick={this.toggle}
                />
              }
              {this.props.children}
            </div>
          </div>
        }
      </Fragment>
    );
  }
}

export default Modal;
